export default __webpack_public_path__ + "static/media/arrowRight.9f02a1c2.svg";